import React, { useState, useEffect, useRef } from "react"
import Dropdown from "../Dropdown/Dropdown"
import {
  marketOptions,
  normalizeMarketRegionCode,
  findMarketRegion,
  findMarketSubRegionOption,
  findMarketRegionByCode,
  getSubRegionDropdownOptions,
  getAllSubRegionDropdownOptions,
  regionHasSubRegions,
  buildMarketCode,
} from "../CompanyUserInfo/options/marketOptions"
import styles from "./index.module.scss"

const firstOption = {
  id: "All",
  value: "All",
}

export const MarketSelectorView = ({ market, onChange }) => {
  const [regionValue, setRegionValue] = useState({})
  const [subRegionValue, setSubRegionValue] = useState(firstOption)
  const prevMarketRef = useRef(market)
  const hasSelectedRegion = Boolean(regionValue?.databaseName)
  const regionSubRegions = hasSelectedRegion
    ? getSubRegionDropdownOptions(regionValue)
    : getAllSubRegionDropdownOptions()
  const showSubRegionFilter =
    !hasSelectedRegion || regionHasSubRegions(regionValue)
  const subRegionOptions = showSubRegionFilter
    ? [firstOption, ...regionSubRegions]
    : []

  useEffect(() => {
    if (!market) {
      setRegionValue({})
      setSubRegionValue(firstOption)
      prevMarketRef.current = market
      return
    }

    const region = findMarketRegion(market) ?? {}
    setRegionValue(region)
    setSubRegionValue(findMarketSubRegionOption(market) ?? firstOption)

    const prev = prevMarketRef.current
    const prevCode =
      prev != null && prev !== "" ? normalizeMarketRegionCode(prev) : ""
    const code = normalizeMarketRegionCode(market)
    if (prevCode && prevCode !== code) {
      setSubRegionValue(firstOption)
    }

    prevMarketRef.current = market
  }, [market])

  const handleSubRegionChange = (_, value) => {
    setSubRegionValue(value)
    if (value.id === firstOption.id) {
      onChange(regionValue.databaseName || "")
      return
    }

    const regionCode =
      regionValue.databaseName || value.regionDatabaseName
    if (!regionValue.databaseName && value.regionDatabaseName) {
      const region = findMarketRegionByCode(value.regionDatabaseName)
      if (region) setRegionValue(region)
    }

    onChange(buildMarketCode(regionCode, value.databaseName))
  }

  return (
    <div className={styles.root}>
      <p className={styles.label}>Market</p>
      <Dropdown
        name="market_region"
        placeholder="Select Region"
        fieldStyle="black"
        className={styles.dropdown}
        options={marketOptions}
        value={regionValue}
        onChange={(_, value) => {
          setRegionValue(value)
          setSubRegionValue(firstOption)
          onChange(value.databaseName)
        }}
      />
      {showSubRegionFilter && (
        <Dropdown
          name="market_subregion"
          fieldStyle="black"
          className={styles.dropdown}
          placeholder={
            hasSelectedRegion && regionValue.databaseName === "CA"
              ? "Select province"
              : "Select country"
          }
          options={subRegionOptions}
          value={subRegionValue}
          onChange={handleSubRegionChange}
        />
      )}
    </div>
  )
}
